// DeploymentMode — controls ingestion Stage 2 behavior (CLAUDE.md #6).
// hybrid + on_prem are behind FEATURE_FLAG_HYBRID_ONPREM=false until Q4 2026.
// Documents from those modes route to `csai-ingestion-hybrid` topic — NOT DLQ.
import { z } from "zod";
export const DeploymentModeSchema = z.enum(["saas", "hybrid", "on_prem"]);
export const DEPLOYMENT_MODES = DeploymentModeSchema.options;
// The gate for hybrid/on-prem + all of E-L2-RESIDENCY. Off until Q4 2026; the
// engineer flips it to "true" in a test env to exercise the resident path.
export const FEATURE_FLAG_HYBRID_ONPREM_ENV = "FEATURE_FLAG_HYBRID_ONPREM";
export function isHybridOnPremEnabled(env = process.env) {
    return env[FEATURE_FLAG_HYBRID_ONPREM_ENV] === "true";
}
//# sourceMappingURL=DeploymentMode.js.map